import * as React from "react";

const InputPlusDisabled: React.FC = () => (
    <svg
        width="10px"
        height="10px"
        viewBox="0 0 10 10"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <polygon
            fill="currentColor"
            points="5.577 .577 5.577 0 4.423 0 4.423 .577 4.423 4.423 .577 4.423 0 4.423 0 5.577 .577 5.577 4.423 5.577 4.423 9.423 4.423 10 5.577 10 5.577 9.423 5.577 5.577 9.423 5.577 10 5.577 10 4.423 9.423 4.423 5.577 4.423"
            opacity=".33"
        />
    </svg>
);

export default React.memo(InputPlusDisabled);
